import { render, staticRenderFns } from "./PaymentImages.vue?vue&type=template&id=38dde942&scoped=true"
import script from "./PaymentImages.vue?vue&type=script&lang=js"
export * from "./PaymentImages.vue?vue&type=script&lang=js"
import style0 from "./PaymentImages.vue?vue&type=style&index=0&id=38dde942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dde942",
  null
  
)

export default component.exports